import React from 'react'
import { ReactTerminal, TerminalContextProvider } from "react-terminal";
const Terminal = () => {
    // Define commands here
    const commands = {
        whoami: "fexa",
        cd: (directory) => `changed path to ${directory}`,
    ls: () => "about.md  contact.md  index.md  projects.md  README.md  resume.md",
    cat: (file) => `cat: ${file}: No such file or directory`,
    help: () => "cd  help  ls  whoami  cat about contact",
    about: () => "regular linux user",
    contact: () => "me kyu batau",
    };

    return (

            <div className="terminal_container">
            <div className="terminal">
                <TerminalContextProvider>
                <ReactTerminal
                    commands={commands}
                    themes={{
                        darkDefault: {
                            themeBGColor: "#0b0e12",
                            themeToolbarColor: "#0b0e12",
                            themeColor: "#90a6c0",
                            themePromptColor: "#c09090"

                        },
                    }}
                    prompt="fexa@portfolio:~$ "
                    theme="darkDefault"
                 />
                </TerminalContextProvider>
            </div>
            </div>
    );
}
export default Terminal
